<template>
  <div>
    <menu-pages-navbar class="mb-3" />
    <!-- MenuCategories -->
    <div>
      <!-- Buttons -->
      <v-layout
        align-center
        wrap
      >
        <!-- Enable customize-order mode -->
        <v-btn
          v-if="!sortModeEnabled"
          class="ml-0 mr-auto"
          style="font-weight: normal; text-transform: none"
          small
          round
          flat
          :disabled="menuCategories.length < 2"
          @click="sortModeEnabled = true"
        >
          <v-icon left>
            sort
          </v-icon>
          {{ $t('menuCategoriesReorder') }}
        </v-btn>
        <v-layout
          v-else-if="!loadingCategories"
          align-center
          justify-start
          wrap
          class="mt-2"
        >
          <v-btn
            class="ml-0"
            round
            small
            flat
            @click="sortModeEnabled = false"
          >
            {{ $t('menuCategoriesReorderCancel') }}
          </v-btn>
          <v-btn
            class="ml-1"
            round
            small
            flat
            @click="sortMenuCategoriesByName()"
          >
            <v-icon
              class="mr-2"
              style="font-size: 20px"
            >
              sort_by_alpha
            </v-icon>
            {{ $t('menuCategoriesReorderByName') }}
          </v-btn>
          <v-btn
            color="msr"
            small
            dark
            round
            @click="confirmSortedMenuCategories()"
          >
            {{ $t('menuCategoriesReorderConfirm') }}
          </v-btn>
        </v-layout>
        <!-- Create MenuCategory Button -->
        <v-btn
          v-if="!sortModeEnabled"
          data-cy="add-menucategory-btn"
          color="msr"
          class="mt-3 mr-0"
          dark
          round
          :title="$t('menuCategoriesAddNew')"
          @click="startCreatingMenuCategory()"
        >
          <v-icon left>
            add
          </v-icon>
          {{ $t('menuCategory') }}
        </v-btn>
      </v-layout>
      <v-data-table
        v-if="!sortModeEnabled"
        hide-actions
        disable-initial-sort
        :headers="menuCategoryHeaders"
        :items="menuCategories"
        :loading="loadingCategories"
        :no-data-text="loadingCategories ? '' : $t('menuCategoriesNoDataText')"
        class="mt-3"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr :key="props.item.id">
            <!-- Name -->
            <td
              class="clickable"
              :title="$t('edit')"
              @click="startEditingMenuCategory(props.item)"
            >
              <v-chip
                label
                class="grey lighten-3 body-1 mx-0 outlined--dark"
                style="user-select: none; pointer-events: none"
              >
                {{ props.item.name }}
              </v-chip>
            </td>
            <!-- Details -->
            <td
              v-if="showMenuCategoryDetails"
              class="clickable"
              :title="$t('edit')"
              @click="startEditingMenuCategory(props.item)"
            >
              <span
                style="
                  display: inline-block;
                  white-space: pre-line;
                  max-width: 200px;
                  max-height: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >{{ props.item.details }}</span>
            </td>
            <!-- TimeFrames -->
            <td
              v-if="showMenuCategoryTimeframes"
              class="clickable"
              :title="$t('edit')"
              @click="startEditingMenuCategory(props.item)"
            >
              <v-layout align-center>
                <v-icon
                  v-if="(props.item.timeframes || []).length > 0"
                  :color="props.item.active_now ? 'success' : 'error'"
                  :title="
                    props.item.active_now
                      ? $t('menuCategoryTimeframesActiveNow')
                      : $t('menuCategoryTimeframesInactiveNow')
                  "
                  class="mr-3"
                  style="cursor: help"
                >
                  timelapse
                </v-icon>
                <entry-timeframe
                  :timeframes="props.item.timeframes || []"
                  :show-icon="false"
                />
              </v-layout>
            </td>
            <!-- Background -->
            <td
              v-if="showMenuCategoryBackgrounds"
              class="clickable"
              :title="$t('edit')"
              @click="startEditingMenuCategory(props.item)"
            >
              <v-layout
                v-if="props.item.background"
                column
                justify-center
                class="mt-1 mb-2"
              >
                <div class="mb-1">
                  {{ props.item.background.name }}
                </div>
                <img
                  v-for="image in props.item.background.images
                    .filter((x) => x.mode == 'MENU_PAGE')
                    .slice(0, 1)"
                  :key="image.id"
                  :src="image.image_file"
                  class="mr-2"
                  style="max-width: 64px; max-height: 64px; object-fit: contain"
                  :style="{
                    'aspect-ratio': image.aspect_ratio,
                  }"
                >
              </v-layout>
            </td>
            <!-- Number of menu items used on -->
            <td
              class="category-link-wrapper"
              :title="$t('goToMenuCategoryMenuItems')"
              @click="
                $router.push({
                  name: 'menuitems',
                  params: {menuId: menuId},
                  query: {category: props.item.id},
                })
              "
            >
              <v-icon color="grey lighten-1">
                fastfood
              </v-icon>
              <span
                style="
                  display: inline-block;
                  min-width: 32px;
                  text-align: right;
                "
                class="category-link unselectable mx-0 subheading"
                :class="{
                  'grey--text text--darken-1':
                    props.item.num_menu_items_used_on > 0,
                  'error--text': props.item.num_menu_items_used_on == 0,
                }"
              >
                <strong>{{ props.item.num_menu_items_used_on }}</strong>
              </span>
            </td>
            <!-- Number of players used on -->
            <td
              :class="{
                'decoders-link-wrapper': props.item.num_players_used_on > 0,
              }"
              :title="$t('goToMenuCategoryDecoders')"
              @click="
                props.item.num_players_used_on > 0
                  ? $router.push({
                    name: 'menucategorydecoders',
                    params: {menuId: menuId},
                    query: {search: props.item.name},
                  })
                  : null
              "
            >
              <span
                v-if="props.item.num_players_used_on > 0"
                style="display: inline-flex"
                class="decoders-link unselectable mx-0 subheading"
                :class="{
                  'grey--text text--darken-1':
                    props.item.num_players_used_on > 0,
                  'error--text': props.item.num_players_used_on == 0,
                }"
              >
                <icon-tv-decoder
                  :tvdecoder="{is_menu_player: true, aspect_ratio: 16 / 9}"
                  class="mr-1"
                  :color="props.item.num_players_used_on > 0 ? 'grey' : 'error'"
                />
                <strong
                  style="
                    display: inline-block;
                    min-width: 32px;
                    text-align: right;
                  "
                >{{ props.item.num_players_used_on }}</strong>
              </span>
              <div v-if="props.item.num_players_used_on == 0">
                <router-link
                  data-cy="menucategories-assign-to-decoders-btn"
                  :to="{
                    name: 'menucategorydecoders',
                    params: {menuId: menuId},
                  }"
                >
                  {{ $t('menuCategoryDecodersLinkForNewMenuCategoryUnused') }}
                </router-link>
              </div>
            </td>
            <!-- Delete -->
            <td
              style="width: 32px; padding-right: 0"
              :title="$t('remove')"
            >
              <v-btn
                class="my-0 grey--text"
                icon
                flat
                :disabled="loadingCategories"
                @click="confirmDeleteMenuCategory(props.item)"
              >
                <v-icon> delete </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- 'Sort mode' categories list -->
      <div
        v-else
        class="mt-4"
      >
        <div class="unselectable grey--text text--darken-3 mb-2">
          {{ $t('menuCategoriesReorderHint') }}
        </div>
        <div class="full-width">
          <sortable-menu-categories
            v-model="sortableMenuCategories"
            class="white"
          />
        </div>
      </div>
    </div>
    <!-- Scroll Spacer -->
    <div style="min-height: 60px" />
    <!-- Create MenuCategory Dialog -->
    <create-edit-menu-category-dialog
      :show.sync="showCreateEditMenuCategoryDialog"
      :show-menu-category-details="(menu || {}).show_menu_category_details"
      :show-menu-category-timeframes="
        (menu || {}).show_menu_category_timeframes
      "
      :show-menu-category-backgrounds="
        (menu || {}).show_menu_category_backgrounds
      "
      :menu-id="menuId"
      :menu-categories="menuCategories"
      :edited-menu-category="editedMenuCategory"
      @save="(payload) => onMenuCategorySaved(payload)"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import orderBy from 'lodash.orderby';

import {removeUrlQueryParamsFromCurrentRoute} from '@/utils';

import CreateEditMenuCategoryDialog from '@/components/Menu/CreateEditMenuCategoryDialog';
import EntryTimeframe from '@/components/EntryTimeframe';
import IconTvDecoder from '@/components/IconTvDecoder';
import MenuPagesNavbar from '@/components/Menu/MenuPagesNavbar';
import SortableMenuCategories from '@/components/Menu/SortableMenuCategories';

export default {
  components: {
    CreateEditMenuCategoryDialog,
    EntryTimeframe,
    IconTvDecoder,
    MenuPagesNavbar,
    SortableMenuCategories,
  },
  data() {
    return {
      loadingMenu: false,
      loadingCategories: false,

      editedMenuCategory: null,
      showCreateEditMenuCategoryDialog: false,

      sortModeEnabled: false,
      sortableMenuCategories: [],

      // From backend.
      menu: null,
    };
  },
  computed: {
    ...mapState({
      menuCategories: (state) => state.common.menuCategories,
      menuItems: (state) => state.common.menuItems,
    }),
    showMenuCategoryDetails() {
      if (!this.menu) {
        return false;
      }
      return this.menu.show_menu_category_details;
    },
    showMenuCategoryTimeframes() {
      if (!this.menu) {
        return false;
      }
      return this.menu.show_menu_category_timeframes;
    },
    showMenuCategoryBackgrounds() {
      if (!this.menu) {
        return false;
      }
      return this.menu.show_menu_category_backgrounds;
    },
    menuCategoryHeaders() {
      const headers = [
        {
          text: this.$t('name'),
          value: 'name',
          sortable: false,
        },
        this.showMenuCategoryDetails
          ? {
              text: this.$t('menuCategoryDetails'),
              value: 'details',
              sortable: false,
            }
          : null,
        this.showMenuCategoryTimeframes
          ? {
              text: this.$t('menuCategoryTimeframes'),
              value: 'timeframes',
              sortable: false,
            }
          : null,
        this.showMenuCategoryBackgrounds
          ? {
              text: this.$t('menuCategoryBackground'),
              value: 'backgrounds',
              sortable: false,
            }
          : null,
        {
          text: this.$t('menuCategoryNumMenuItemsUsedOn'),
          value: 'num_menu_items_used_on',
          sortable: false,
        },
        {
          text: this.$t('menuCategoryNumPlayersUsedOn'),
          value: 'num_players_used_on',
          sortable: false,
        },
      ];
      return headers.filter((header) => header != null);
    },
    categoryIdIsUsedInMenuItems() {
      const categoryIdToUsed = {};
      for (const menuItem of this.menuItems) {
        categoryIdToUsed[menuItem.category.id] = true;
      }
      return categoryIdToUsed;
    },
    ruleFactories() {
      /**
       *  Create rules that need knowledge about which item is being edited.
       */
      return {
        menuCategoryMustHaveUniqueName: (menuCategory) => {
          const vm = this;
          function rule(name) {
            const otherMenuCategoryNames = vm.menuCategories
              .filter((category) => category.id !== menuCategory.id)
              .map((category) => category.name.toLowerCase());
            return (
              !otherMenuCategoryNames.includes(name.toLowerCase()) ||
              vm.$t('alreadyInUse')
            );
          }
          return rule;
        },
      };
    },
    menuId() {
      return this.$route.params.menuId;
    },
  },
  watch: {
    sortModeEnabled: function (sortModeEnabled) {
      if (sortModeEnabled) {
        // Copy current categories list so we can resort/modify it.
        // We'll use it to update the actual category order at the end.
        this.sortableMenuCategories = this.menuCategories.slice();
      }
    },
  },
  methods: {
    startCreatingMenuCategory() {
      this.stopEditingMenuCategory();
      this.showCreateEditMenuCategoryDialog = true;
    },
    startEditingMenuCategory(menuCategory) {
      this.editedMenuCategory = menuCategory;
      this.showCreateEditMenuCategoryDialog = true;
    },
    stopEditingMenuCategory() {
      this.editedMenuCategory = null;
      this.showCreateEditMenuCategoryDialog = false;
    },
    onMenuCategorySaved(menuCategory) {
      if (this.editedMenuCategory) {
        this.updateMenuCategory(menuCategory);
        this.stopEditingMenuCategory();
      } else {
        this.createMenuCategory(menuCategory);
        this.showCreateEditMenuCategoryDialog = false;
      }
    },
    sortMenuCategoriesByName() {
      this.sortableMenuCategories = orderBy(this.sortableMenuCategories, [
        (category) => category.name.toLowerCase(),
      ]);
    },
    confirmSortedMenuCategories() {
      const orderedMenuCategoryIds = this.sortableMenuCategories.map(
        (category) => category.id
      );
      this.$api
        .reorderMenuCategories(this.menuId, orderedMenuCategoryIds)
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'menuCategoriesReorderedSuccess',
            translate: true,
          });

          // Update store state so other pages look correct.
          this.$store.dispatch('LIST_MENU_CATEGORIES', this.menuId);
          this.$store.dispatch('LIST_MENU_ITEMS', this.menuId);
        });

      // Frontend update
      this.$store.commit('SET_MENU_CATEGORIES', this.sortableMenuCategories);
      this.sortModeEnabled = false;
    },
    createMenuCategory(payload) {
      this.$api.createMenuCategory(this.menuId, payload).then(() => {
        this.fetchMenuCategories();
        this.fetchMenuItems();
      });
    },
    updateMenuCategory(menuCategory) {
      this.$api
        .updateMenuCategory(menuCategory.id, menuCategory)
        .catch((error) => {
          console.error(error);
          this.$bus.$emit('alert-error', {
            message: 'genericFailFeedback',
            translate: true,
          });
        })
        .finally(() => {
          this.fetchMenuCategories();
          this.fetchMenuItems();
        });
    },
    confirmDeleteMenuCategory(menuCategory) {
      const vm = this;

      const title = this.$t('menuCategoryConfirmDeletionTitle', {
        name: menuCategory.name,
      });
      const hint1 = this.$t('menuCategoryConfirmDeletionHint_1');
      const hint2 = this.$t('menuCategoryConfirmDeletionHint_2', {
        num: menuCategory.num_menu_items_used_on,
      });

      let warningElement = '';
      if (menuCategory.num_menu_items_used_on > 0) {
        warningElement = `
          <div class="bg-error pa-2 error--text mt-2">
            <strong>${hint2}</strong>
          </div>
        `;
      }

      this.$bus.$emit('show-dynamic-dialog', {
        title: title,
        titleIcon: 'menu_book',
        persistent: true,
        content: `
          <div class="subheading">
            ${hint1}
            ${warningElement}
          </div>
        `,
        onConfirm() {
          const dialog = this;
          dialog.loading = true;
          vm.$api
            .deleteMenuCategoryWithMenuItems(menuCategory.id)
            .then(() => {
              vm.fetchMenuCategories();
              vm.fetchMenuItems();
              vm.$bus.$emit('hide-dynamic-dialog');
            })
            .finally(() => {
              dialog.loading = false;
            });
        },
      });
    },
    fetchData() {
      const promises = [
        this.fetchMenu({indicator: true}),
        this.fetchMenuCategories({indicator: true}),
      ];

      if (!this.menuItems.length) {
        promises.push(this.fetchMenuItems());
      }

      return Promise.all(promises);
    },
    fetchMenu({indicator = false} = {}) {
      if (indicator) {
        this.loadingMenu = true;
      }
      return this.$api
        .retrieveMenu(this.menuId)
        .then((response) => {
          this.menu = response.data;
        })
        .finally(() => (this.loadingMenu = false));
    },
    fetchMenuCategories({indicator = false} = {}) {
      if (indicator) {
        this.loadingCategories = true;
      }
      return this.$store
        .dispatch('LIST_MENU_CATEGORIES', this.menuId)
        .finally(() => (this.loadingCategories = false));
    },
    fetchMenuItems() {
      return this.$store.dispatch('LIST_MENU_ITEMS', this.menuId);
    },
    handleQueryParams() {
      if (!this.$route.query) {
        return;
      }
      const editThisCategoryId = this.$route.query.edit;
      if (!editThisCategoryId) {
        return;
      }

      for (let i = 0; i < this.menuCategories.length; i++) {
        const menuCategory = this.menuCategories[i];
        if (menuCategory.id == editThisCategoryId) {
          this.startEditingMenuCategory(menuCategory);
          removeUrlQueryParamsFromCurrentRoute();
          break;
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData().then(() => {
        vm.$nextTick(() => {
          vm.handleQueryParams();
        });
      });
    });
  },
};
</script>

<style scoped>
.category-link-wrapper {
  cursor: pointer;
}
.category-link-wrapper:hover .category-link {
  text-decoration: underline;
  color: var(--msr-color-primary) !important;
}

.decoders-link-wrapper {
  cursor: pointer;
}
.decoders-link-wrapper:hover .decoders-link {
  text-decoration: underline;
  color: var(--msr-color-primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/MenuCategories.vue